import { render, staticRenderFns } from "./CollabListNoLongerCollaborative.vue?vue&type=template&id=35651c2e&scoped=true&"
import script from "./CollabListNoLongerCollaborative.vue?vue&type=script&lang=js&"
export * from "./CollabListNoLongerCollaborative.vue?vue&type=script&lang=js&"
import style0 from "./CollabListNoLongerCollaborative.vue?vue&type=style&index=0&id=35651c2e&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35651c2e",
  null
  
)

export default component.exports